import { Link, List, ListItem, Typography } from '@mui/material';

export const HighYieldSavingsProducts = () => (
  <>
    <Typography sx={{ paddingBottom: { sx: '0rem', md: '1.5rem' } }}>
      Did you know you could earn up to 10x more in interest with a high-yield savings product
      compared to a traditional savings account? Add compound interest to the equation, and you'll
      be on track for exponential, effortless growth.
    </Typography>
    <Typography variant="textBold">Here's how it works:</Typography>
    <List sx={{ listStyleType: 'disc', marginLeft: '1.2rem' }}>
      <ListItem sx={{ display: 'list-item', padding: '0 0 0.5rem 0' }}>
        You make an initial deposit. In this illustration, we've assumed an amount of $10,000
      </ListItem>
      <ListItem sx={{ display: 'list-item', padding: '0 0 0.5rem 0' }}>
        You let that sum sit for a period of time; in our example, we've used 5 years
      </ListItem>
      <ListItem sx={{ display: 'list-item', padding: '0 0 0.5rem 0' }}>
        Say you sign up for a high-yield savings product, offering an APY (annual percentage yield)
        of 4.00%, and that rate compounds monthly
      </ListItem>
      <ListItem sx={{ display: 'list-item', padding: '0 0 0.5rem 0' }}>
        Assuming you keep your balance at $10,000 over those 5 years and make no additional
        deposits, you'll earn $2,209.97 in interest! Compare that to only $207.08 earnings with a
        traditional savings account APY of 0.41%
      </ListItem>
    </List>
    <Typography>
      You can explore further using{' '}
      <Link href="https://www.nerdwallet.com/calculator/compound-interest-calculator">
        NerdWallet's Compound Interest Calculator.
      </Link>
    </Typography>
  </>
);

export const HighYieldSavings = () => (
  <>
    <Typography sx={{ paddingBottom: { sx: '0rem', md: '1.5rem' } }}>
      Did you know you could earn up to 10x more in interest with a high-yield savings account
      compared to a traditional savings account? Add compound interest to the equation, and you'll
      be on track for exponential, effortless growth.
    </Typography>
    <Typography variant="textBold">Here's how it works:</Typography>
    <List sx={{ listStyleType: 'disc', marginLeft: '1.2rem' }}>
      <ListItem sx={{ display: 'list-item', padding: '0 0 0.5rem 0' }}>
        You make an initial deposit into your account. In this illustration, we've assumed an amount
        of $10,000
      </ListItem>
      <ListItem sx={{ display: 'list-item', padding: '0 0 0.5rem 0' }}>
        You let that sum sit in your account for a period of time; in our example, we've used 5
        years
      </ListItem>
      <ListItem sx={{ display: 'list-item', padding: '0 0 0.5rem 0' }}>
        Say you sign up for a high-yield savings account with a bank offering an APY (annual
        percentage yield) of 4.00%, and that rate compounds monthly
      </ListItem>
      <ListItem sx={{ display: 'list-item', padding: '0 0 0.5rem 0' }}>
        Assuming you keep your balance at $10,000 over those 5 years and make no additional
        deposits, you'll earn $2,209.97 in interest! Compare that to only $207.08 earnings with a
        traditional savings account APY of 0.41%
      </ListItem>
    </List>
    <Typography>
      You can explore further using NerdWallet's{' '}
      <Link href="https://www.nerdwallet.com/calculator/compound-interest-calculator">
        Compound Interest Calculator.
      </Link>
    </Typography>
  </>
);
